module.exports = __webpack_public_path__ + "static/media/welcome-hand-pork.c72e548e.svg";